module.exports = __webpack_public_path__ + "static/31-42694f499d52475d190ffbd30833f947.png";